module.exports = __webpack_public_path__ + "img/12_klio_09.7b8ddc68.jpg";